import React from 'react';
interface CTAButtonProps {
  className?: string;
  showPrice?: boolean;
}
export function CTAButton({
  className = '',
  showPrice = true
}: CTAButtonProps) {
  const handleScrollToCTA = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!showPrice) {
      e.preventDefault();
      const finalCTASection = document.getElementById('final-cta-section');
      if (finalCTASection) {
        finalCTASection.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (showPrice && typeof window !== 'undefined' && window.fbq) {
      // Prevent immediate navigation
      e.preventDefault();
      // Fire AddToCart event
      window.fbq('track', 'AddToCart', {
        content_name: 'EMPRENDE USA EXPRESS',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
      console.log('Meta Pixel: AddToCart event fired');
      // Navigate after a short delay to ensure the event is sent
      const targetUrl = e.currentTarget.href;
      setTimeout(() => {
        window.location.href = targetUrl;
      }, 300);
    } else {
      handleScrollToCTA(e);
    }
  };
  return <div className={className} data-id="element-1">
      {/* Pricing - only show if showPrice is true */}
      {showPrice && <div className="flex items-center justify-center gap-3 md:gap-4 mb-4 md:mb-6" data-id="element-2">
          <span className="text-text-secondary text-lg md:text-2xl line-through" data-id="element-3">
            $47
          </span>
          <span className="text-cta text-3xl md:text-5xl font-bold" data-id="element-4">$6.39</span>
          <span className="bg-red-500/20 text-red-400 text-xs md:text-sm font-semibold px-2 md:px-3 py-1 rounded-full" data-id="element-5">
            86% OFF
          </span>
        </div>}

      <a href={showPrice ? 'https://rrdigitalpro.com/cart/44859706998838:1' : '#final-cta-section'} onClick={handleClick} className="block w-full bg-cta text-cta-text font-semibold text-base md:text-lg px-6 md:px-8 py-4 md:py-5 rounded-lg hover:bg-opacity-90 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02] text-center" aria-label="Acceder al Sistema EMPRENDE USA EXPRESS" data-id="element-6">
        Acceder al Sistema EMPRENDE USA EXPRESS
      </a>
      <p className="text-center text-text-secondary text-xs md:text-sm mt-3 md:mt-4" data-id="element-7">
        Acceso inmediato • Ebook PDF • Sistema completo paso a paso
      </p>
    </div>;
}